function addDaysISO(isoDate, days) {
  const [y, m, d] = isoDate.split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  dt.setDate(dt.getDate() + days);
  const yy = dt.getFullYear();
  const mm = String(dt.getMonth() + 1).padStart(2, '0');
  const dd = String(dt.getDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

function daysBetween(fromIso, toIso) {
  const [y1, m1, d1] = fromIso.split('-').map(Number);
  const [y2, m2, d2] = toIso.split('-').map(Number);
  const a = Date.UTC(y1, m1 - 1, d1);
  const b = Date.UTC(y2, m2 - 1, d2);
  return Math.round((b - a) / 86400000);
}

/** Resolve forecast window from import metadata (API max 183 days). */
export function resolveForecastRange(viewDate, imports, maxDays = 183) {
  const importStart = imports?.date_range_start?.slice?.(0, 10);
  const importEnd = imports?.date_range_end?.slice?.(0, 10);

  let from = importStart || viewDate;
  let to = importEnd || addDaysISO(viewDate, maxDays - 1);

  if (from > to) {
    to = addDaysISO(from, maxDays - 1);
  }

  let span = daysBetween(from, to) + 1;
  if (span > maxDays) {
    const offset = daysBetween(from, viewDate);
    if (offset < maxDays / 2) {
      to = addDaysISO(from, maxDays - 1);
    } else {
      from = addDaysISO(viewDate, -Math.floor(maxDays / 2));
      to = addDaysISO(from, maxDays - 1);
    }
    span = maxDays;
  }

  return { from, to, span };
}

export { addDaysISO, daysBetween };
